import DataManager from 'utils/DataManager/dataManager';
import { DataState } from 'typings/enums';
import { IPromotionRequest } from 'typings/promotion';
import { IPromotionRequestDataManager } from 'typings/dataManagers';
import {
    IUpdatePromotionJobEvent,
    IUpdatePromotionRequestNewTitleEvent,
    IUpdatePromotionRequestAmountEvent
} from 'typings/promotion';

class PromotionRequestDataManager extends DataManager implements IPromotionRequestDataManager {
    getPromotionRequestData(
        masterAccountId: string,
        cycleId: number,
        employeeSourceId: string,
        promotionId: string): Promise<Nullable<IPromotionRequest>> {
        const receive = () => this._getDataRequest<IPromotionRequest>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/promotion/${promotionId}?employeeSourceId=${encodeURIComponent(employeeSourceId)}`);
        return this.getData<IPromotionRequest>(receive, false);
    }

    createPromotionRequest(
        masterAccountId: string,
        cycleId: number,
        employeeSourceId: string): Promise<Nullable<string>> {
        const receive = () => this._postDataRequest<null, string>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/promotion?employeeSourceId=${encodeURIComponent(employeeSourceId)}`,
            null);
        return this.getData<string>(receive, false);
    }

    async updatePromotionRequestData(
        masterAccountId: string,
        cycleId: number,
        employeeSourceId: string,
        promotionId: string,
        // tslint:disable-next-line:max-line-length
        events: Array<IUpdatePromotionJobEvent | IUpdatePromotionRequestNewTitleEvent | IUpdatePromotionRequestAmountEvent>): Promise<void> {
        // tslint:disable-next-line:max-line-length
        const receive = () => this._postDataRequest<Array<IUpdatePromotionJobEvent | IUpdatePromotionRequestNewTitleEvent | IUpdatePromotionRequestAmountEvent>, void>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/promotion/${promotionId}/events?employeeSourceId=${encodeURIComponent(employeeSourceId)}`,
            events);
        await this.getData<void>(receive, false);
    }

    async deletePromotionRequest(
        masterAccountId: string,
        cycleId: number,
        employeeSourceId: string,
        promotionId: string): Promise<void> {
        const receive = () => this._deleteDataRequest<void>(
            // tslint:disable-next-line:max-line-length
            `/api/accounts/${masterAccountId}/team/cycles/${cycleId}/employees/promotion/${promotionId}?employeeSourceId=${encodeURIComponent(employeeSourceId)}`);
        await this.getData<void>(receive, false);
    }

    setDataState(state: DataState): void {
        this.protectedTransitionDataState(state);
    }
}

export { PromotionRequestDataManager };
export default PromotionRequestDataManager;